import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

import { createAuthSlice, type AuthSlice } from './auth';
import { createProfileSlice, type ProfileSlice } from './profile';
import { createMerchantRoleAccessSlice, type MerchantRoleAccessSlice } from './role-access';

export const STORAGE_KEY = 'dashboard-merchant-storage';

// Note: Do update the type whenever new slice are added
export type GlobalStore = AuthSlice & ProfileSlice & MerchantRoleAccessSlice;

export const useStore = create<
  GlobalStore,
  [
    [
      'zustand/persist',
      Pick<GlobalStore, 'accessToken' | 'refreshToken' | 'shownPopupAnnountcement'>,
    ],
  ]
>(
  persist(
    (...a) => ({
      ...createAuthSlice(...a),
      ...createProfileSlice(...a),
      ...createMerchantRoleAccessSlice(...a),
    }),
    {
      name: STORAGE_KEY,
      storage: createJSONStorage(() => localStorage),
      partialize: (state) => ({
        accessToken: state.accessToken,
        refreshToken: state.refreshToken,
        shownPopupAnnountcement: state.shownPopupAnnountcement,
      }),
    },
  ),
);
